export const prepareArray = (arr, func, field) => {
  arr.forEach(el => {
    if (el[field]) {
      el[field] = func(el[field])
    }
  })
}

export const prepareArrayWithTwoParams = (arr, func, field1, field2) => {
  arr.forEach(el => {
    if (el[field1]) {
      el[field1] = func(el[field1], el[field2])
    }
  })
}

export const getHashCurrentBundle = () => {
  const list = document.getElementsByTagName('script')
  const arrayOfScripts = Array.prototype.slice.call(list).map(el => el.src)
  const path = arrayOfScripts.find(el => el.match('static/js/app'))
  return path ? path.match(/(\d+\w+).js$/)[1] : path
}

export const trimString = (string, length) => (string.length > length ? `${string.slice(0, length)}...` : string)

export const createArrayOfNumbers = number => {
  const results = []
  for (let i = 0; i < number; i++) {
    results.push(i)
  }
  return results
}

export const getInnerTextFromHtmlString = html => {
  return `${html}`.replace(/(<([^>]+)>)/gi, '')
}

export const isSafariMobile = () => {
  const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/)
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

  return isSafari && iOS
}
